function adminReducer(state = {}, action) {
  switch (action.type) {
    case "LOGIN":
      return { ...action.payload };
    case "LOGOUT":
      return {};
    case "UNSET_LOGGED_MESSAGE":
      const admin = { ...action.payload };
      admin.messageLogged = false;
      return admin;
    default:
      return state;
  }
}
export default adminReducer;
